<template lang="pug">
transition(name="bounce", mode="out-in")
    v-btn(
        :key="selected.name",
        v-bind="$attrs",
        v-on="$listeners",
        text,
        :color="selected.color || 'textColor'"
        :disabled="disabled"
    )
        v-icon(
            left,
            :color="selected.color || 'textColor'",
            :size="selected.size"
        ) {{ selected.icon }}
        span(:style="labelStyles") {{ selected.label }}
</template>

<script lang="ts">
import Vue from "vue"
import THEME from "../../constants/theme"

export default Vue.extend({
  name: "ReactionTextButton",
  props: {
    selected: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      labelStyles: THEME.typography.button,
    }
  },
})
</script>

<style lang="sass" scoped>
.bounce-enter-active
    transition: opacity .2s, transform .2s ease-in-out
    transform: scale(0.8)
.bounce-leave-active
    transition: opacity .2s
.bounce-enter
    opacity: 0
    transform: scale(1.4)
.bounce-leave-to
    opacity: 0
</style>
>
